AlertScriptController.$inject = ["_", "alertScriptTypes", "vehicleTypes", "$filter", "$sce", "$translate"];
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.slice.js";
/* injects from baggage-loader */
require('./alert-script.component.html');
import angular from 'angular';
angular.module('AaApp.Opp').component('alertScript', {
  templateUrl: '/app/components/deal-sheet/alert-script.component.html',
  controller: AlertScriptController,
  bindings: {
    type: '<',
    culture: '<',
    opportunity: '<',
    userFullName: '<',
    isCrossMake: '<',
    customScripts: '<'
  }
});

/* @ngInject */
function AlertScriptController(_, alertScriptTypes, vehicleTypes, $filter, $sce, $translate) {
  var $ctrl = this;
  $ctrl.alertScriptTypes = alertScriptTypes;
  $ctrl.vehicleTypes = vehicleTypes;
  $ctrl.alertScriptTypeKeys;
  $ctrl.customScriptHtml = null;
  $ctrl.$onInit = init;
  $ctrl.$onChanges = onChanges;
  function init() {
    $ctrl.alertScriptTypeKeys = _.invert(alertScriptTypes);
    updateCustomScript();
  }
  function onChanges() {
    updateCustomScript();
  }
  function updateCustomScript() {
    var script = findCustomScript();
    if (!script || !script.scriptBody) {
      $ctrl.customScriptHtml = null;
      return;
    }
    $ctrl.customScriptHtml = $sce.trustAsHtml(replaceTokens(script.scriptBody));
  }
  function findCustomScript() {
    if (!$ctrl.customScripts || !$ctrl.customScripts.length || !$ctrl.type) {
      return null;
    }
    var matching = $ctrl.customScripts.filter(function (script) {
      return script.scriptTypeID === $ctrl.type;
    });
    if (!matching.length) {
      return null;
    }
    var culture = resolveCulture();
    var exact = findByCulture(matching, culture);
    if (!exact) {
      exact = findByFallbackCulture(matching, culture);
    }
    return exact || matching[0];
  }
  function resolveCulture() {
    var culture = $ctrl.culture || $translate.use() || $translate.proposedLanguage();
    return normalizeCulture(culture);
  }
  function normalizeCulture(culture) {
    return (culture || '').toLowerCase().replace('_', '-');
  }
  function findByCulture(scripts, culture) {
    if (!culture) {
      return null;
    }
    return _.find(scripts, function (script) {
      return normalizeCulture(script.culture) === culture;
    });
  }
  function findByFallbackCulture(scripts, culture) {
    var fallbacks = [];
    var normalized = normalizeCulture(culture);
    if (normalized) {
      fallbacks.push(normalized);
    }
    if (normalized.indexOf('en-') === 0) {
      fallbacks.push('en-us', 'en-ca');
    } else if (normalized.indexOf('fr-') === 0) {
      fallbacks.push('fr-ca', 'fr-fr');
    }
    fallbacks.push('en-us', 'en-ca');
    for (var i = 0; i < fallbacks.length; i++) {
      var match = findByCulture(scripts, fallbacks[i]);
      if (match) {
        return match;
      }
    }
    return null;
  }
  function replaceTokens(scriptBody) {
    var tokens = buildTokenMap();
    var output = scriptBody;
    Object.keys(tokens).forEach(function (key) {
      var value = tokens[key];
      if (value === null || value === undefined) {
        value = '';
      }
      output = output.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'gi'), value);
    });
    return output;
  }
  function buildTokenMap() {
    var currency = $filter('localeCurrency');
    var number = $filter('localeNumber');
    var translate = $filter('translate');
    var opportunity = $ctrl.opportunity || {};
    var customer = opportunity.customer || {};
    var dealer = opportunity.dealer || {};
    var currentVehicle = opportunity.currentVehicle || {};
    var replacementVehicle = opportunity.replacementVehicle || {};
    var currentContract = opportunity.currentContract || {};
    var replacementContract = opportunity.replacementContract || {};
    var creditPreApproval = opportunity.creditPreApproval;
    var privateOfferInfo = opportunity.privateOfferInfo;
    return {
      customerName: wrapStrong(customer.fullName),
      userFullName: wrapStrong($ctrl.userFullName),
      loggedUser: wrapStrong(resolveLoggedUser(dealer, currentVehicle)),
      make: wrapStrong(currentVehicle.makeName),
      replacementModel: wrapStrong(replacementVehicle.modelName),
      existingModel: wrapStrong(currentVehicle.modelName),
      paymentsLeft: wrapStrong(currentContract.paymentsRemaining),
      year: wrapStrong(currentVehicle.yearID ? currentVehicle.yearID : translate('unknown')),
      trim: wrapStrong(currentVehicle.trimFullName),
      shortVin: wrapStrong(resolveShortVin(currentVehicle.vin)),
      currentPayment: wrapStrong(currency(currentContract.payment)),
      currentMileagePenalty: wrapStrong(currency(currentContract.currentMileagePenalty)),
      newOrNewer: wrapStrong(resolveNewOrNewer(replacementVehicle)),
      projectedMileagePenalty: wrapStrong(currency(currentContract.estimatedMileagePenalty)),
      currentMileage: wrapStrong(number(currentVehicle.odometer)),
      allowedMileage: wrapStrong(number(currentContract.allowedMileage)),
      projectedMileage: wrapStrong(number(currentContract.estimatedMaturityMileage)),
      lastOdemeterRead: wrapStrong(number(currentContract.estimatedCurrentMileage)),
      creditPreapprovalAmount: wrapStrong(currency(creditPreApproval ? creditPreApproval.approvalAmount : '(unknown)')),
      factoryRebateAmount: wrapStrong(currency(replacementContract.factoryRebate)),
      replacementTrimFull: wrapStrong(replacementVehicle.trimFullName),
      replacementYear: wrapStrong(replacementVehicle.yearID),
      privateOfferAmount: wrapStrong(currency(privateOfferInfo ? privateOfferInfo.privateOfferAmount : '(unknown)'))
    };
  }
  function resolveLoggedUser(dealer, currentVehicle) {
    if ($ctrl.isCrossMake || dealer.name) {
      return dealer.name;
    }
    return currentVehicle.makeName;
  }
  function resolveShortVin(vin) {
    if (!vin) {
      return '';
    }
    return vin.length <= 8 ? vin : vin.slice(-8);
  }
  function resolveNewOrNewer(replacementVehicle) {
    if (!replacementVehicle || replacementVehicle.vehicleType === undefined) {
      return '';
    }
    return replacementVehicle.vehicleType == $ctrl.vehicleTypes.new ? 'new' : 'newer';
  }
  function wrapStrong(value) {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return '<strong>' + value + '</strong>';
  }
}